module.exports = __webpack_public_path__ + "img/unext_pirates2.6566e6ef.png";